import * as Dialog from "@radix-ui/react-dialog";
import { useRef, type ReactNode } from "react";
import { useT } from "../i18n/I18nProvider";
import { Icon } from "./Icon";

/** Dialog with focus trap, Escape to close and focus return to whatever had focus when it opened, from Radix primitives. */
export function Modal({ open, onOpenChange, title, description, children, wide = false, dismissible = true }: { open: boolean; onOpenChange: (open: boolean) => void; title: string; description?: string; children: ReactNode; wide?: boolean; dismissible?: boolean }) {
  const t = useT();
  // Dialogs here are opened from state, not a Dialog.Trigger, so Radix has no trigger to hand focus back to: remember who had it.
  const opener = useRef<Element | null>(null);
  return (
    <Dialog.Root open={open} onOpenChange={(next) => { if (next || dismissible) onOpenChange(next); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="cc-overlay" />
        <Dialog.Content
          className={wide ? "cc-modal cc-modal--wide" : "cc-modal"}
          onOpenAutoFocus={() => {
            opener.current = document.activeElement;
          }}
          onCloseAutoFocus={(event) => {
            event.preventDefault();
            if (opener.current instanceof HTMLElement && opener.current.isConnected) opener.current.focus();
          }}
        >
          <div className="cc-modal__header">
            <Dialog.Title className="cc-modal__title">{title}</Dialog.Title>
            <Dialog.Close className="cc-icon-button" aria-label={t("common.close")} disabled={!dismissible}>
              <Icon name="close" />
            </Dialog.Close>
          </div>
          {description ? <Dialog.Description className="cc-modal__description">{description}</Dialog.Description> : null}
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
